import sender from './sender/store';
import template from './template/store';
import log from './log/store';
import option from './option/store';
import notice from './notice/store';

export default {
  namespaced: true,
  modules: { sender, template, log, option, notice },
};
